module.exports = __webpack_public_path__ + "img/guanghua-tab2.ac5bef5a.png";